export const projectCards = [
  {
    name: "Burger Kenzie",
    img: "https://i.imgur.com/rtwm2Kr.png",
    site: "https://react-burguer-kenzie.vercel.app/",
    rep: "https://github.com/maiceljunior/REACT--BurguerKenzie",
  },
  {
    name: "KenzieGram",
    img: "https://i.imgur.com/LSj2Hkf.png",
    site: "https://maiceljunior.github.io/CSS--Kenziegram/",
    rep: "https://github.com/maiceljunior/CSS--Kenziegram",
  },
  {
    name: "Biscoito Aleatório",
    img: "https://i.imgur.com/KIuttTO.png",
    site: "https://maiceljunior.github.io/JS--randomCookie/",
    rep: "https://github.com/maiceljunior/JS--randomCookie",
  },
  {
    name: "Nu Kenzie",
    img: "https://i.imgur.com/mMlrqVo.png",
    site: "https://react-nu-kenzie.vercel.app/",
    rep: "https://github.com/maiceljunior/REACT---nuKenzie",
  },
  {
    name: "Pizzaria da Kenzie",
    img: "https://i.imgur.com/MgcM2oQ.png",
    site: "https://react-entrega-s3-kenzieshop-maiceljunior.vercel.app",
    rep: "",
  },
  {
    name: "Organiza Ai",
    img: "https://i.imgur.com/pur8cCc.png",
    site: "https://capstone-organiza-ai-m3.vercel.app/",
    rep: "https://github.com/maiceljunior/capstone-organiza-ai-m3",
  },

  {
    name: "Quadro de Medalhas",
    img: "https://i.imgur.com/Wwbo2Id.png",
    site: "https://musical-eureka-c6576cf5.pages.github.io/",
    rep: "",
  },
  {
    name: "Torre de Hanoi",
    img: "https://i.imgur.com/UzVPiel.png",
    site: "https://kenzie-academy-brasil-developers.github.io/m2-entrega-torre-de-hanoi-sprint-1a-maiceljunior/",
    rep: "",
  },
  {
    name: "Estilização de Cardápio",
    img: "https://i.imgur.com/IJyLYPX.png",
    site: "https://kenzie-academy-brasil-developers.github.io/m1-entrega-s1-estilizando-menu-restaurante-maiceljunior/#",
    rep: "",
  },
  {
    name: "Formulário de Cadastro",
    img: "https://i.imgur.com/g6C7eyg.png",
    site: "https://react-atividade-s2-praticando-forms-maiceljunior.vercel.app/",
    rep: "",
  },
  {
    name: "Kenzie Hub",
    img: "https://i.imgur.com/ULKd4uD.png",
    site: "https://react-entrega-s2-kenzie-hub-maiceljunior.vercel.app",
    rep: "",
  },
  {
    name: "Lista de Produtos",
    img: "https://i.imgur.com/ehn9lNv.png",
    site: "https://upgraded-meme-98ea7baa.pages.github.io/",
    rep: "",
  },
  {
    name: "Cadastro de Pessoas",
    img: "https://i.imgur.com/VhQmnqQ.png",
    site: "https://kenzie-academy-brasil-developers.github.io/m2-entrega-cadastro-de-pessoas-maiceljunior/",
    rep: "",
  },

  {
    name: "Blog Api",
    img: "https://i.imgur.com/15xZLh5.png",
    site: "https://turbo-enigma-ec8328cc.pages.github.io/",
    rep: "",
  },

  {
    name: "Personanges Rick e Morty",
    img: "https://i.imgur.com/7ORk1sy.png",
    site: "https://react-atividade-s1-buscando-mais-personagens-maiceljunior.vercel.app/",
    rep: "",
  },
];
